"use client"

import clsx from "clsx"

export type NpPaginationDotsProps = {
  count: number
  activeIndex: number
  overlayed?: boolean
}

export const NpPaginationDots = ({ count, activeIndex, overlayed }: NpPaginationDotsProps) => {
  return (
    <div className="group pointer-events-none inline-flex h-4 items-center justify-center rounded-full">
      {Array.from({ length: count }).map((_, index) => {
        const active = index === activeIndex

        return (
          <div key={index} className="flex size-4 items-center justify-center outline-none">
            <div
              className={clsx("size-2 rounded-full", {
                "bg-np-green25": !active,
                "bg-np-green": active,
                "mix-blend-plus-lighter": overlayed,
              })}
            />
          </div>
        )
      })}
    </div>
  )
}
